import articlesApi from '@/api/articles'

const state = {
  articleTypes: [
    'primary',
    'success',
    'danger',
    'warning',
    'info',
  ],
  createDialogOpen: false,
  editDialogOpen: false,
  editItemId: null,
  list: [],
}

export const mutationTypes = {
  setCreateDialogOpen: '[articles] set creteDialogOpen',
  setEditDialogOpen: '[articles] set editDialogOpen',
  setEditItemId: '[articles] set editItemId',
  setList: '[articles] set list',
  deleteItem: '[articles] delete item'
}

const mutations = {
  [mutationTypes.setCreateDialogOpen](state, payload) {
    state.createDialogOpen = payload
  },
  [mutationTypes.setEditDialogOpen](state, payload) {
    state.editDialogOpen = payload
  },
  [mutationTypes.setEditItemId](state, payload) {
    state.editItemId = payload
  },
  [mutationTypes.setList](state, payload){
    state.list = payload
  },
  [mutationTypes.deleteItem](state, payload){
    state.list = state.list.filter(item => item.id != payload)
  }
}

export const actionTypes = {
  setCreateDialogOpen: '[articles] set creteDialogOpen',
  loadList: '[articles] load list',
  addItem: '[articles] add item',
  deleteItem: '[articles] delete item',
  updateItem: '[articles] update item',
  setShow: '[articles] set show'
}

const actions = {
  [actionTypes.setCreateDialogOpen](context, isOpen){
    return new Promise(resolve => {
      context.commit(mutationTypes.setCreateDialogOpen, isOpen)
      resolve(isOpen)
    })
  },
  [actionTypes.loadList](context){
    return new Promise((resolve) => {
      articlesApi
        .getList()
        .then((response) => context.commit(mutationTypes.setList, response.data))
      resolve()
    })
  },
  [actionTypes.addItem](context, payload){
    console.log(payload)
    return new Promise(resolve => {
      articlesApi
        .addItem(payload)
        .then((response) => context.commit(mutationTypes.setList, response.data))
      resolve()
    })
  },
  [actionTypes.deleteItem](context, payload){
    return new Promise(resolve => {
      articlesApi
        .deleteItem(payload)
        .then(() => context.commit(mutationTypes.deleteItem, payload))
      resolve()
    })
  },
  [actionTypes.updateItem](context, payload){
    return new Promise(resolve => {
      articlesApi
        .updateItem(context.state.editItemId, payload)
        .then((response) => {
          let newList = context.state.list.map(item => {
            if(item.id == response.data.id){
              item = response.data
            }
            return item
          })
          context.commit(mutationTypes.setList, newList)
          resolve(response.data)
        })
    })
  },
  [actionTypes.setShow](context, {id, show}){
    return new Promise(resolve => {
      articlesApi
        .updateItem(id, {show})
        .then((response) => {
          let newList = context.state.list.map(item => {
            if(item.id == response.data.id){
              item = response.data
            }
            return item
          })
          context.commit(mutationTypes.setList, newList)
          resolve(response.data)
        })
    })
  }
}

export default {
  state,
  mutations,
  actions,
}
